var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 4.5C29.7956 4.5 30.5587 4.81607 31.1213 5.37868C31.6839 5.94129 32 6.70435 32 7.5V28.5C32 29.2956 31.6839 30.0587 31.1213 30.6213C30.5587 31.1839 29.7956 31.5 29 31.5H8C7.20435 31.5 6.44129 31.1839 5.87868 30.6213C5.31607 30.0587 5 29.2956 5 28.5V7.5C5 6.70435 5.31607 5.94129 5.87868 5.37868C6.44129 4.81607 7.20435 4.5 8 4.5H29ZM28.25 27.75V19.8C28.25 18.5031 27.7348 17.2593 26.8178 16.3422C25.9007 15.4252 24.6569 14.91 23.36 14.91C22.085 14.91 20.6 15.69 19.88 16.86V15.195H15.695V27.75H19.88V20.355C19.88 19.2 20.81 18.255 21.965 18.255C22.522 18.255 23.0561 18.4762 23.4499 18.8701C23.8438 19.2639 24.065 19.798 24.065 20.355V27.75H28.25ZM10.82 12.84C11.4883 12.84 12.1293 12.5745 12.6019 12.1019C13.0745 11.6293 13.34 10.9883 13.34 10.32C13.34 8.925 12.215 7.785 10.82 7.785C10.1477 7.785 9.50289 8.05208 9.02748 8.52748C8.55208 9.00289 8.285 9.64768 8.285 10.32C8.285 11.715 9.425 12.84 10.82 12.84ZM12.905 27.75V15.195H8.75V27.75H12.905Z",
    fill: "#4C89FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLinkedin);
export default __webpack_public_path__ + "static/media/c_linkedin.089cb73fac08df8b9cbe5b70a52132f0.svg";
export { ForwardRef as ReactComponent };